// Resolves the row to highlight when jumping into the roster. Rows use `emp-<employeeId>` as their
// DOM id, which isn't unique (an employee can span departments), so scope to the department
// wrapper when given one; otherwise fall back to the first match.
export function findEmployeeRow(
    root: ParentNode,
    employeeId: number,
    departmentId?: number | null
): HTMLElement | null {
    const scope = departmentId != null ? root.querySelector(`.department[data-department="${departmentId}"]`) : null;
    const selector = `#emp-${employeeId}`;
    // Fall back to the first match when the scoped department has no such row (e.g. the jump-in
    // department differs from where the employee actually renders) so the highlight still lands.
    return scope?.querySelector(selector) ?? root.querySelector(selector);
}
